import { QueryClient, QueryClientProvider, QueryCache } from '@tanstack/react-query';
import { ReactNode } from 'react';
import { isRetryable, unhandledError } from '../api/global-error-handler';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => unhandledError(error, 'query'),
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => isRetryable(error, failureCount),
    },
    mutations: {
      retry: false,
      onError: (error) => unhandledError(error, 'mutation'),
    },
  },
});

export function QueryProvider({ children }: { children: ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
